module.exports = __webpack_public_path__ + "img/roadmap-phase-2-cell-2-icon.52a5699e.svg";